<template>
  <el-dialog
    :custom-class="$style.dialog"
    :visible="true"
    title="域名转入结果"
    @close="close"
  >
    <el-table
      ref="multipleTable"
      :data="showList"
      :fit="true"
      border
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" width="50" align="center">
        <template slot-scope="scope">{{
          limit * (page - 1) + scope.$index + 1
        }}</template>
      </el-table-column>

      <el-table-column prop="name" label="域名" width="120" align="center" />

      <el-table-column prop="content" label="结果" width="120" align="center" />
    </el-table>

    <Row :class="$style.actions">
      <el-pagination
        :class="$style.pagination"
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
      <Button type="primary" @click="confirm">确定</Button>
    </Row>
  </el-dialog>
</template>

<script>
export default {
  name: "EnterResultPopup",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      page: 1,
      limit: 10,
      showList: [],
    };
  },
  computed: {
    total() {
      return this.showList.length;
    },
  },

  methods: {
    getShowList(page = 1) {
      this.page = page;
      const startIndex = (page - 1) * this.limit;
      const endIndex = startIndex + this.limit;

      this.showList = this.list.slice(startIndex, endIndex);
    },

    handlePageChange(page) {
      this.getShowList(page);
    },

    confirm() {
      this.close();
    },

    close() {
      this.page = 1;
      this.status = 0;
      this.$emit("close");
    },
  },
  created() {
    this.getShowList();
  },
};
</script>

<style lang="scss" module scoped>
::v-deep .dialog {
  width: auto;

  :global {
    .el-dialog__body {
      min-width: 700px;
      padding-top: 20px;

      ::v-deep.el-table__body-wrapper {
        min-height: unset;
      }
    }

    .gl-button {
      margin: 0;
    }

    .el-table {
      max-height: 50vh;
      @include scrollbar();

      .el-table__body-wrapper {
        .el-table__cell {
          background-color: $white !important;
        }
      }
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: rem(20);
    margin-top: rem(10);
    border-top: $border-1;
  }
}
</style>
